<template>
	<div class="custom-table" :class="{'flex-column': height == 'grow', 'flex-grow': height == 'grow'}">
		<div class="custom-table-operate flex">
			<m-operate>
				<slot name="operate"></slot>
				<c-button v-if="batchEdit" prepend-icon="tf-edit" @click="batchEditHandle">批量填充</c-button>

				<template #right>
					<slot name="otherOperate"></slot>
				</template>
			</m-operate>
			<m-operate>
				<template #right>
					<c-button prepend-icon="tf-field-config" @click="globalDialog('fieldConfig', {props: {viewId: viewId}}, updateColumn)">字段配置</c-button>
				</template>
			</m-operate>
		</div>

		<c-table v-paste ref="list" border :height="height" :paging="paging" width-resize @widthResize="widthResizeHandle" @dataChange="selectHandle">
			<template v-if="$scopedSlots.empty" #empty>
				<slot name="empty"></slot>
			</template>
			
			<c-table-column v-if="drag"
				key="drag"
				type="drag"
				@handle="$emit('drag')"
			></c-table-column>
			
			<c-table-column v-if="selector || batchEdit || summed"
				key="selector"
				:type="selector || batchEdit ? 'selector' : 'index'"
				width="32"
				:summed="summedRow"
				@handle="selectHandle"
			>
				<template #summed>
					<div class="flex-center" style="height: 10px; margin: 0 -5px;">
						<p style="line-height: 14px; font-size: 11px; text-align: center;">合计</p>
					</div>
				</template>
			</c-table-column>

			<slot></slot>
			
			<template v-for="(col, i) in columnList">
				<template v-if="col.is_display == 1">
					<c-table-column
						v-if="!col.is_custom"
						:key="col.field_code"
						:label="col.field_title"
						:name="col.field_code"
						:width="col.width"
						:fixed="col.is_lock == 1 ? 'left' : false"
						:required="col.is_required == 1"
						:summed="
							summed && col.field_type == 2 && col.is_summed == 1
								? ({data}) => parseFloat(data[col.field_code]) || 0
								: false
						"
						:ellipsis="!col.config_json || !col.config_json.page_config || col.config_json.page_config.ellipsis != 0"
					>
						<template v-if="$scopedSlots[col.field_code]" #default="{index, data, nodeData, update, remove, expand}">
							<slot :name="col.field_code" :index="index" :data="data" :nodeData="nodeData" :update="update" :remove="remove" :expand="expand"></slot>
						</template>

						<template v-if="$scopedSlots[`${col.field_code}_tip`]" #tip>
							<slot :name="`${col.field_code}_tip`"></slot>
						</template>

						<template v-if="$scopedSlots[`${col.field_code}_summed`]" #summed="{total}">
							<slot :name="`${col.field_code}_summed`" :total="parseFloat(total.toFixed(6))"></slot>
						</template>
						<template v-else-if="readonly && $scopedSlots[col.field_code]" #summed="{total}">
							<slot :name="col.field_code" :data="{[col.field_code]: parseFloat(total.toFixed(6))}"></slot>
						</template>
						<template v-else #summed="{total}">
							<span>{{parseFloat(total.toFixed(6))}}</span>
						</template>
					</c-table-column>

					<c-table-column
						v-else
						:key="col.field_code"
						:label="col.field_title"
						:name="col.field_code"
						:width="col.width"
						:fixed="col.is_lock == 1 ? 'left' : false"
						:required="col.config_json.attr.includes('required')"
						:summed="
							summed && col.config_json.type == 'number'
								? ({data}) => parseFloat(data.custom_fields_value_json[col.field_code]) || 0
								: false"
					>
						<template v-if="readonly" #default="{data}">
							<c-file-list v-if="['file', 'image'].includes(customConfig[col.field_code].type)" :value="data.custom_fields_value_json[col.field_code]" size="mini"></c-file-list>
							<c-tags v-else-if="typeof data.custom_fields_value_json[col.field_code] == 'object'" :value="data.custom_fields_value_json[col.field_code]"></c-tags>
							<div v-else-if="customConfig[col.field_code].type == 'text' && customConfig[col.field_code].attr.includes('textarea')" style="max-height: 75px; overflow: auto; white-space: pre-wrap;">{{data.custom_fields_value_json[col.field_code] || '-'}}</div>
							<span v-else-if="customConfig[col.field_code].type == 'rel_object'">{{data.customFieldValues[col.field_code].display_value || '-'}}</span>
							<span v-else>{{data.custom_fields_value_json[col.field_code] || '-'}}</span>
						</template>
						
						<template v-else #default="{data, key}">
							<c-input v-if="customConfig[col.field_code].type == 'text'"
								v-model="data.custom_fields_value_json[col.field_code]"
								:type="customConfig[col.field_code].attr.includes('textarea') ? 'textarea' : 'text'"
								:disabled="customConfig[col.field_code].attr.includes('readonly')"
								:placeholder="customConfig[col.field_code].placeholder"
								:name="col.config_json.attr.includes('required') ? col.field_code : ''"
								:suggest="col.config_json.attr.includes('suggest') ? {empty: true, add: col.config_json.attr.includes('addSuggest') ? '新预设值' : false} : false"
								:height-resize="{type: 'focus-auto', maxHeight: '140px'}"
								@suggest="suggestHandle(col, arguments[0], arguments[1])"
								@add="addCustomSuggest(col, arguments[0], arguments[1])"
							></c-input>

							<c-input v-else-if="customConfig[col.field_code].type == 'number'"
								v-model="data.custom_fields_value_json[col.field_code]"
								type="number"
								:decimal="customConfig[col.field_code].attr.includes('decimal') ? customConfig[col.field_code].decimal : 0"
								:disabled="customConfig[col.field_code].attr.includes('readonly')"
								:placeholder="customConfig[col.field_code].placeholder"
								:name="col.config_json.attr.includes('required') ? col.field_code : ''"
							></c-input>

							<c-datetime v-else-if="customConfig[col.field_code].type == 'time'"
								v-model="data.custom_fields_value_json[col.field_code]"
								:type="customConfig[col.field_code].format.split('|')[1]"
								:format="customConfig[col.field_code].format.split('|')[0]"
								:time-accuracy="customConfig[col.field_code].format.split('|')[2]"
								:disabled="customConfig[col.field_code].attr.includes('readonly')"
								:placeholder="customConfig[col.field_code].placeholder || '请选择'"
								:name="col.config_json.attr.includes('required') ? col.field_code : ''"
							></c-datetime>

							<c-select v-else-if="customConfig[col.field_code].type == 'option'"
								v-model="data.custom_fields_value_json[col.field_code]"
								:options="customConfig[col.field_code].options"
								:multiple="customConfig[col.field_code].attr.includes('multiple')"
								:placeholder="customConfig[col.field_code].placeholder || '请选择'"
								:search="{add: customConfig[col.field_code].attr.includes('add')}"
								:name="col.config_json.attr.includes('required') ? col.field_code : ''"
								@add="addCustomOption(col, arguments[0], arguments[1], arguments[2])"
							></c-select>

							<c-upload-file v-else-if="['file', 'image'].includes(customConfig[col.field_code].type)"
								v-model="data.custom_fields_value_json[col.field_code]"
								input
								:type="customConfig[col.field_code].type == 'file' ? customConfig[col.field_code].suffix.join(',') : 'image'"
								:multiple="customConfig[col.field_code].attr.includes('multiple') ? 30 : false"
								:name="col.config_json.attr.includes('required') ? col.field_code : ''"
							></c-upload-file>

							<c-select v-else-if="customConfig[col.field_code].type == 'rel_object'"
								v-model="data.custom_fields_value_json[col.field_code]"
								:name="col.config_json.attr.includes('required') ? col.field_code : ''"
								:value-data="objectValueData[key] ? objectValueData[key][col.field_code] : undefined"
								:placeholder="customConfig[col.field_code].placeholder || '请选择'"
								async
								@search="searchObjectOption(col, arguments[0], arguments[1])"
								@change="objectFieldHandle(col, $event, data)"
							></c-select>
						</template>

						<template v-if="col.config_json.tip" #tip>
							<c-tooltip align="end" :tip="col.config_json.tip"></c-tooltip>
						</template>
						
						<template #summed="{total}">
							<span>{{parseFloat(total.toFixed(6))}}</span>
						</template>
					</c-table-column>
				</template>
			</template>
		</c-table>
	</div>
</template>

<script>
	export default {
		name: 'customTable',

		props: {
			workType: [String, Number],
			viewId: [String, Number],
			border: {
				type: Boolean,
				default: true
			},
			paging: Boolean,
			drag: Boolean,
			selector: Boolean,
			batchEdit: [Boolean, Function],
			readonly: Boolean,
			summed: {
				type: Boolean,
				default: true
			},
			height: {
				type: [String, Number],
				default: 'auto'
			}
		},

		data() {
			return {
				customConfig: {},
				columnList: [],
				objectValueData: {},

				batchEditRow: []
			}
		},

		computed: {
			required() {
				let list = [];
				this.columnList.forEach(item => {
					if (item.is_custom == 1 && item.config_json.attr.includes('required')) {
						list.push(item.field_code);
					}
				});
				return list;
			},

			defaultData() {
				let data = {}, object = false;
				this.columnList.map(item => {
					if (item.is_custom == 1 && item.config_json.default) {
						if (item.config_json.default.type == 1) {
							if (item.config_json.type == 'time') {
								data[item.field_code] = new Date().format(item.config_json.format.split('|')[0]);
							} else {
								data[item.field_code] = item.config_json.default.value;
							}
						} else if (item.config_json.default.type == 2) {
							object = true;
						}
					}
				})

				return {
					data,
					object
				}
			},

			summedRow() {
				return this.summed && !!this.columnList.find(col => col.is_display == 1 && (col.is_custom ? col.config_json.type == 'number' : (col.field_type == 2 && col.is_summed == 1)));
			}
		},

		mounted() {
			this._getObjectValueData = () => {
				this.$nextTick(() => {
					this.$refs.list.getRow().forEach(({key, data}) => {
						data = data.customFieldValues;
						this.$set(this.objectValueData, key, {})
						Object.keys(data).forEach(code => {
							if (data[code].display_value) {
								this.$set(this.objectValueData[key], code, [{
									name: data[code].display_value,
									value: data[code].value
								}])
							}
						});
					});
				});
			}

			this._setTableData = this.$refs.list.setData;
			this.$refs.list.setData = list => {
				list.forEach(item => item.custom_fields_value_json = item.custom_fields_value_json || {});
				this._setTableData(list);
				this._getObjectValueData();
			}
			this._pushTableData = this.$refs.list.push;
			this.$refs.list.push = list => {
				this._pushTableData(list);
				this._getObjectValueData();
			}
		},

		methods: {
			init() {
				this.objectValueData = {};
				!this.paging && this._setTableData([]);
				this.updateColumn();
			},

			updateColumn() {
				this.request({
					url: '/sys_user_view/field_list',
					data: {
						view_id: this.viewId
					},
					success: data => {
						let config = {};
						data.field_list.forEach(item => {
							if (item.is_custom) {
								config[item.field_code] = item.config_json;
							}
						});
						this.customConfig = config;
						this.columnList = [];
						this.$nextTick(() => {
							this.columnList = data.field_list;

							if (this._defaultQueue) {
								this.$nextTick(() => {
									this._defaultQueue.forEach(item => {
										item();
									});
									delete this._defaultQueue;
								});
							}
						});
					}
				});
			},

			setDefaultData(target, source) {
				return new Promise(resolve => {
					let handler = () => {
						let single = false;
						if (!Array.isArray(target) && typeof target == 'object') {
							single = true;
							target = [target];
						}

						if (this.defaultData.object && source) {
							this.request({
								url: '/sys_field/default/values',
								data: source,
								loading: !single,
								success: data => {
									if (typeof target == 'function') {
										resolve(target(data.map(item => Object.assign(item, this.defaultData.data))));
									} else {
										target.forEach((item, index) => item.custom_fields_value_json = Object.assign(data[index], this.defaultData.data, item.custom_fields_value_json));
										resolve(single ? target[0] : target);
									}
								}
							})
						} else {
							if (typeof target == 'function') {
								resolve(target(source.source_list.map(() => Object.assign({}, this.defaultData.data))));
							} else {
								target.forEach(item => item.custom_fields_value_json = Object.assign({}, this.defaultData.data, item.custom_fields_value_json));
								resolve(single ? target[0] : target);
							}
						}
					}
					
					if (!this.columnList.length) {
						if (!this._defaultQueue) {
							this._defaultQueue = [];
						}
						this._defaultQueue.push(handler);
					} else {
						handler();
					}
				});
			},

			validate() {
				let row = this.$refs.list.getData().find(row => {
					return this.required.find(item => {
						let val = row.custom_fields_value_json[item];
						if (Array.isArray(val)) {
							return !val.length;
						} else {
							return !val && val !== 0;
						}
					})
				})
				return row ? '请完善带星号的必填字段' : true;
			},

			widthResizeHandle(col) {
				let item = this.columnList.find(item => item.field_code == col.name);
				if (item) {
					item.width = col.width;
					this.request({
						url: '/sys_user_view/edit_field',
						data: {
							view_id: this.viewId,
							field_list: this.columnList.map(item => {
								return {
									field_id: item.field_id,
									width: item.width,
									is_display: item.is_display,
									is_lock: item.is_lock
								}
							})
						}
					})
				}
			},

			suggestHandle(item, keyword, resolve) {
				if (item.config_json.attr.includes('suggest')) {
					resolve(item.config_json.suggest.filter(item => item.includes(keyword)));
				}
			},

			addCustomSuggest(item, value, resolve) {
				this.request({
					url: '/sys_field/edit',
					data: {
						id: item.field_id,
						field_title: item.field_title,
						config_json: JSON.stringify(Object.assign({}, item.config_json, {
							suggest: item.config_json.suggest.map(item => item).concat([value])
						}))
					},
					loading: true,
					success: () => {
						resolve(value);
						item.config_json.suggest.push(value);
					}
				});
			},

			addCustomOption(item, event, name, resolve) {
				let option = {
					name,
					value: name
				}
				this.request({
					url: '/sys_field/edit',
					data: {
						id: item.field_id,
						field_title: item.field_title,
						config_json: JSON.stringify(Object.assign({}, item.config_json, {
							options: item.config_json.options.map(item => item).concat([option])
						}))
					},
					loading: true,
					success: () => {
						resolve(option);
						this.updateColumn();
					}
				});
			},

			searchObjectOption(field, keyword, resolve) {
				this.request({
					url: '/sys_field/relation/data_list',
					data: {
						relation_field_id: field.field_id,
						keyword
					},
					success: data => {
						resolve(data.map(item => {
							return {
								name: item.display_value,
								value: item.id
							}
						}))
					}
				})
			},

			objectFieldHandle(field, data, rowData) {
				data.value && this.request({
					url: '/sys_field/relation/fill',
					data: {
						work_type_id: this.workType,
						relation_field_id: field.field_id,
						target_id: data.value
					},
					success: data => {
						Object.keys(data).forEach(key => {
							this.$set(rowData.custom_fields_value_json, key, data[key]);
						})
					}
				})
			},

			selectHandle() {
				this.batchEditRow = this.$refs.list.getRow('selected');
			},

			batchEditHandle() {
				if (!this.batchEditRow.length) {
					this.$message({
						message: '请选择要批量填充的行'
					});
					return;
				}
				this.globalDialog('workFieldEdit', {
					props: {
						fill: true,
						viewId: this.viewId
					}
				}, ({field, value, extend}) => {
					if (extend.objectFieldValue) {
						this.objectValueData = {};
						this.batchEditRow.forEach(({key}) => {
							this.$set(this.objectValueData, key, {
								[field.field_code]: extend.objectFieldValue.value ? [extend.objectFieldValue] : []
							})
						});
						extend.objectFieldValue.value && this.request({
							url: '/sys_field/relation/fill',
							data: {
								work_type_id: this.workType,
								relation_field_id: field.id,
								target_id: extend.objectFieldValue.value
							},
							success: data => {
								this.batchEditRow.forEach(({data: rowData}) => {
									Object.keys(data).forEach(key => {
										this.$set(rowData.custom_fields_value_json, key, data[key]);
									})
								});
							}
						});
					} else {
						this.batchEditRow.forEach(({data, update}) => {
							if (field.field_type == 9) {
								this.$set(data.custom_fields_value_json, field.field_code, value);
							} else {
								update({
									[field.field_code]: value
								});
							}
						});
					}
					if (typeof this.batchEdit == 'function') {
						this.batchEdit(field, value, this.batchEditRow);
					}
				});
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.custom-table {
		&-operate {
			>>> .m-operate {
				&[empty] + .m-operate,
				&:nth-child(1) {
					flex-grow: 1;
					width: 0;
					border-left-width: 1px;
				}

				&:nth-child(2) {
					padding-left: 8px;

					^[-2] ^[-1..-1] {
						border-right-width: 1px;
					}
				}

				&:nth-last-child(2) {
					padding-right: 0;
					border-right-width: 0;
				}
			}
		}
	}
</style>
